import React from 'react'
import { h } from 'preact'
import formClosed from '../images/form-closed.png'
import style from './index.scss'

interface Props {
  title: string
  code: string
}

export default function Error({ title, code }: Props) {
  return (
    <div className={style.wrapper}>
      <div className={style.container}>
        <div className={style.emptyPage}>
          <img src={formClosed} alt={code} className={style.image} />
          <div className={style.desc}>{title}</div>
        </div>
      </div>
    </div>
  )
}
